import { render, staticRenderFns } from "./QSfgStats.vue?vue&type=template&id=30cbad99&"
import script from "./QSfgStats.vue?vue&type=script&lang=js&"
export * from "./QSfgStats.vue?vue&type=script&lang=js&"
import style0 from "./QSfgStats.vue?vue&type=style&index=0&id=30cbad99&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports